module.exports = __webpack_public_path__ + "media/proksee-viewer/images/search-contains-be061dbf0b76ab240da6b5665ff68fe6.png";